module.exports = __webpack_public_path__ + "static/gallery_treehouse_3-94454db6079571860642feee3792bacd.jpg";